import styled from 'styled-components';
import { LORAX } from 'HubStyleTokens/colors';
const InProgressDot = styled.div.withConfig({
  displayName: "InProgressDot",
  componentId: "xqb94w-0"
})(["margin-right:6px;background-color:", ";height:6px;width:6px;border-radius:50%;display:inline-block;position:relative;bottom:1px;"], LORAX);
export default InProgressDot;